import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { TableRow } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #e8e8e8', // sombra inferior tabs
    '& .MuiTabs-indicator': {
        backgroundColor: '#19438C', // línea subrayada tabs
    },
});

export const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontSize: 17,
    color: 'black',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: 'red',
        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#19438C', // color tab seleccionado
        fontWeight: theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {
        backgroundColor: '#d1eaff',
    },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#19438C",
      color: theme.palette.common.white,
      fontSize: 16,
      borderLeft: 0, // Elimina el borde izquierdo
      borderRight: 0, // Elimina el borde derecho
  },
  [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
  },
  '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
      backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
  },
}));
